import { Table } from "antd";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

function TableOutput({ output, pagination }) {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [outputJson, setOutputJson] = useState({});

  useEffect(() => {
    try {
      setOutputJson(JSON.parse(output));
    } catch {
      setOutputJson({});
    }
  }, [output]);

  useEffect(() => {
    const headers = outputJson?.column_headers || [];

    setColumns(() => {
      return headers.map((item) => {
        return {
          title: item,
          dataIndex: item,
          key: item,
          width: 150,
        };
      });
    });
  }, [outputJson]);

  useEffect(() => {
    const listOfRows = outputJson?.rows || [];

    setRows(() => {
      return listOfRows.map((item, index) => {
        const obj = {
          key: index + 1,
        };

        columns.forEach((col, colIndex) => {
          obj[col?.key] = item[colIndex];
        });

        return obj;
      });
    });
  }, [columns]);

  if (!columns?.length) {
    return <></>;
  }

  return (
    <div>
      <Table
        columns={columns}
        dataSource={rows}
        size="small"
        scroll={{
          x: "max-content",
        }}
        pagination={{ pageSize: pagination || 5 }}
      />
    </div>
  );
}

TableOutput.propTypes = {
  output: PropTypes.object.isRequired,
  pagination: PropTypes.number,
};

export { TableOutput };
